export default __webpack_public_path__ + "static/media/g_wdt_c_5.a19b7382.mp3";